import { module } from 'angular';

import { AgentBookingVisioAllocated, default as agentBookingVisioAllocated } from './allocated/agent-booking-visio-allocated.component.ajs';
import { AgentBookingVisioInprocess, default as agentBookingVisioInprocess } from './inprocess/agent-booking-visio-inprocess.component.ajs';
import {
  AgentBookingVisioQualification,
  default as agentBookingVisioQualification,
} from './qualification/agent-booking-visio-qualification.component.ajs';

export default module('contact.agent.contact-view.visio.state', [])
  .component(agentBookingVisioAllocated, new AgentBookingVisioAllocated())
  .component(agentBookingVisioInprocess, new AgentBookingVisioInprocess())
  .component(agentBookingVisioQualification, new AgentBookingVisioQualification()).name;
